<template>
  <h1>Tour</h1>
</template>
<script>
export default {
  name: "TourWidget",
  data() {
    return {};
  }
};
</script>
